<!-- <ng-container *ngIf="transaction || transaction.errorType == 0">
    <div nz-row>
        <div nz-col>
            Va multumim pentru plata de {{transaction.amount}}
            <ng-container *ngIf="transaction.transactionSystem == 'Mobilpay - sms'">EUR</ng-container>
            <ng-container *ngIf="transaction.transactionSystem != 'Mobilpay - sms'">RON</ng-container>
            !
        </div>
    </div>
</ng-container> -->
<ng-container *ngIf="!transaction">
  <div nz-row>
    <div nz-col nzSpan="10" class="alert-message-position">
      <ng-container *ngIf="isSubmitAlert == true">
        <nz-alert nzType="info" nzMessage="Procesare E-Factura" nzDescription="E-Factura este in curs de generare si procesare. Te rugam sa astepti..." nzShowIcon></nz-alert>
      </ng-container>
      <ng-container *ngIf="isEfacturaAlertSuccess == true">
        <nz-alert nzType="success" nzMessage="Validare" nzDescription="{{ efacturaMessage }}" nzShowIcon nzCloseable></nz-alert>
      </ng-container>
      <ng-container *ngIf="isEfacturaAlertWarning == true">
        <nz-alert nzType="warning" nzMessage="Atentionare" nzDescription="{{ efacturaMessage }}" nzShowIcon nzCloseable></nz-alert>
      </ng-container>
      <ng-container *ngIf="isEfacturaAlertError == true">
        <nz-alert nzType="error" nzMessage="Eroare" nzDescription="{{ efacturaMessage }}" nzShowIcon nzCloseable></nz-alert>
      </ng-container>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="24" [ngClass]="['p-3', 'anaf-token-status']" *ngIf="userRole == 'admin'">
      <h5 nz-typography style="text-align: right; width: 100%; right: 5rem; position: relative">
        Stare token ANAF:
        <span [ngStyle]="{ color: anafTokenStatus === 'Valid' ? 'green' : 'red' }">
          {{ anafTokenStatus }}
        </span>
      </h5>

      <div style="margin-top: 10px">
        <button nz-button nzType="primary" nzSize="small" style="margin-right: 10px" (click)="generareAnafToken()">Genereaza Token</button>
        <button nz-button nzType="default" nzSize="small" (click)="refreshAnafToken()">Reinoire Token</button>
      </div>
    </div>
  </div>

  <div nz-row>
    <div nz-col nzSpan="16" [ngClass]="'p-3'">
      <h1 nz-typography style="text-align: center">Facturi şi plăţi</h1>

      <!-- <h3 nz-typography style="text-align: center">Poţi edita factura cu datele firmei tale pana cel tarziu patru zile de la data emiterii.</h3> -->
      <h3 nz-typography style="text-align: center">Poţi edita factura cu datele firmei tale până cel târziu patru zile de la data emiterii.</h3>
      <p style="text-align: center">Dacă vrei să ieși din anonimat și să decontezi această cheltuială pe firmă, te rugăm să completezi cu atenție datele de facturare deoarece:</p>
      <ul>
        <li>Am integrat transmiterea automată a facturii către ANAF, iar câmpurile cerute de E-Factura trebuie să corespundă cerințelor solicitate de ANAF.</li>
        <li>La următoarea utilizare a aplicației DoctorBusiness.ro nu mai este nevoie să reintri pentru completarea datelor de facturare, acestea vor fi preluate automat conform informațiilor de facturare anterioare.</li>
        <li>Dacă dorești facturarea acestui serviciu pe firme diferite, poți intra pe "editare factură" și să modifici datele de facturare conform nevoilor tale, în termen de 4 zile de la plata efectuată.</li>
      </ul>

      <!-- <nz-row [nzGutter]="16">
            <nz-col [nzSpan]="6">
                <h5>
                    Conform plăţilor efectuate mai ai disponibile
                    <b>{{ totalBalante }}</b>
                    încărcări de balanţă.
                </h5> -->
      <!-- <nz-statistic
                    *ngIf="!loading"
                    [nzValue]="(totalBalante)!"
                    [nzTitle]="'Total balante pentru procesare'"
                ></nz-statistic> -->
      <!-- </nz-col>
        </nz-row> -->

      <ng-container *ngIf="transaction">
        <nz-result nzStatus="success" *ngIf="transaction.errorType == 0" [nzTitle]="transaction.errorMessage"></nz-result>
        <nz-result nzStatus="error" *ngIf="transaction.errorType == 1" [nzTitle]="transaction.errorMessage"></nz-result>
      </ng-container>

      <nz-pagination class="custom-pagination" nzShowSizeChanger [nzPageIndex]="currentPage" [nzPageSize]="pageSize" [nzPageSizeOptions]="[10, 15, 20, 25, 50, 100]" [nzTotal]="totalItems" (nzPageIndexChange)="onPageChange($event)" (nzPageSizeChange)="onPageSizeChange($event)" style="float: right; margin-bottom: 10px"></nz-pagination>

      <nz-table #transactionsTable [nzData]="transactions" [nzLoading]="loading" [nzPageSize]="pageSize" [nzShowPagination]="false" nzSize="small" style="margin-top: 20px; width: 100%" [nzTableLayout]="!isMobile ? 'fixed' : ''" [nzScroll]="isMobile ? { x: '1300px' } : { x: '1500px' }">
        <!--[nzScroll]="userRole == 'admin' ? { x: '1800px' } : ''"-->
        <thead>
          <tr *ngIf="userRole != 'admin'">
            <th>Tip tranzactie</th>
            <th>Nr factura</th>
            <th style="width: 160px">Factura</th>
            <th>Valoare</th>
            <th>Mesaj</th>
            <th>Data crearii</th>
          </tr>
          <tr *ngIf="userRole == 'admin'">
            <th *ngIf="userRole != 'user'" style="width: 80px" nz-tooltip="ID">Id</th>
            <ng-container *ngIf="userRole != 'user'">
              <th nzWidth="100px" nzCustomFilter style="text-align: center" nz-tooltip="Nume si prenume">
                <div style="display: flex; align-items: center">
                  <input nz-input placeholder="UTILIZATOR" nzBorderless (keyup)="search()" [(ngModel)]="searchNameValue" style="flex: 1" />
                  <button nz-button class="clear-btn" nzType="default" nzSize="small" (click)="clearSearch('searchNameValue')" *ngIf="searchNameValue">x</button>
                </div>
              </th>
            </ng-container>
            <ng-container *ngIf="userRole != 'user'">
              <th nzWidth="140px" nzCustomFilter style="text-align: center" nz-tooltip="Email">
                <input nz-input class="ellipsis-text" placeholder="EMAIL" nzBorderless (keyup)="search()" [(ngModel)]="searchValue" />
                <button nz-button class="clear-btn" nzType="default" nzSize="small" (click)="clearSearch('searchValue')" *ngIf="searchValue">x</button>
              </th>
            </ng-container>
            <ng-container *ngIf="userRole != 'user'">
              <th nzWidth="100px" nzCustomFilter style="text-align: center" nz-tooltip="Tip persoana">
                <div style="display: flex; align-items: center">
                  <input nz-input placeholder="TIP PERSOANA" nzBorderless (keyup)="search()" [(ngModel)]="searchTipPersoana" style="flex: 1" />
                  <button nz-button class="clear-btn" nzType="default" nzSize="small" (click)="clearSearch('searchTipPersoana')" *ngIf="searchTipPersoana">x</button>
                </div>
              </th>
            </ng-container>
            <th nzCustomFilter nzWidth="150px" style="text-align: center" nz-tooltip="Tip tranzactie">
              <div style="display: flex; align-items: center">
                <nz-select class="table-selector" nzBorderless nzShowSearch nzAllowClear nzPlaceHolder="TIP TRANZACȚIE" [(ngModel)]="searchTipTranzactie" (ngModelChange)="search()">
                  <nz-option nzValue="Mobilpay - card" nzLabel="Plată cu Cardul"></nz-option>
                  <nz-option nzValue="Mobilpay - sms" nzLabel="Plată cu SMS"></nz-option>
                  <nz-option nzValue="Mobilpay - carda" nzLabel="Plata abonament"></nz-option>
                  <nz-option nzValue="error1" nzLabel="Eroare plata cu cardul/sms"></nz-option>
                  <nz-option nzValue="error999" nzLabel="Procesare balanţă"></nz-option>
                  <nz-option nzValue="Incarcare cont" nzLabel="Incarcare cont"></nz-option>
                  <nz-option nzValue="Stergere credit din cont" nzLabel="Stergere credit din cont"></nz-option>
                  <!-- <nz-option nzValue="Abonare cu success" nzLabel="Abonare cu success"></nz-option>
                  <nz-option nzValue="Dezabonare cu success" nzLabel="Dezabonare cu success"></nz-option> -->
                </nz-select>
              </div>
            </th>
            <th nzWidth="90px" nzCustomFilter style="text-align: center" nz-tooltip="Numar factura">
              <div style="display: flex; align-items: center">
                <input nz-input placeholder="NR FACTURA" nzBorderless (keyup)="search()" [(ngModel)]="searchNrFactura" style="flex: 1" />
                <button nz-button class="clear-btn" nzType="default" nzSize="small" (click)="clearSearch('searchNrFactura')" *ngIf="searchNrFactura">x</button>
              </div>
            </th>
            <th nzWidth="130px;" nz-tooltip="Factura">Factura</th>
            <th nzCustomFilter style="text-align: center" nz-tooltip="Valoare">
              <div style="display: flex; align-items: center">
                <input nz-input placeholder="VALOARE" nzBorderless (keyup)="search()" [(ngModel)]="searchValoare" style="flex: 1" />
                <button nz-button class="clear-btn" nzType="default" nzSize="small" (click)="clearSearch('searchValoare')" *ngIf="searchValoare">x</button>
              </div>
            </th>
            <th nzWidth="150px" nzCustomFilter style="text-align: center" nz-tooltip="Mesaj">
              <div style="display: flex; align-items: center">
                <nz-select class="table-selector" nzBorderless nzAllowClear nzPlaceHolder="MESAJ" [(ngModel)]="searchMesaj" (ngModelChange)="search()">
                  <nz-option nzValue="Tranzactie aprobata" nzLabel="Tranzactie aprobata"></nz-option>
                  <nz-option nzValue="Trazactie esuata" nzLabel="Trazactie esuata"></nz-option>
                  <nz-option nzValue="Success" nzLabel="Success"></nz-option>
                  <nz-option nzValue="Incarcare cont" nzLabel="Incarcare credit"></nz-option>
                  <nz-option nzValue="Stergere credit din cont" nzLabel="Stergere credit"></nz-option>
                </nz-select>
              </div>
            </th>
            <th nzCustomFilter nzWidth="150px" nz-tooltip="Filtru pentru data creării">
              <nz-date-picker nzMode="month" nzBorderless [(ngModel)]="searchDataCrearii" nzPlaceHolder="DATA CREĂRII" (ngModelChange)="search()"></nz-date-picker>
            </th>
            <th style="width: 100px" *ngIf="userRole == 'admin'" nz-tooltip="E-Factura">e-Factura</th>
            <th nzWidth="90px" nzCustomFilter style="text-align: center" nz-tooltip="Notitele mele">
              <div style="display: flex; align-items: center">
                <input nz-input placeholder="Notitele mele" nzBorderless (keyup)="search()" [(ngModel)]="searchNotes" style="flex: 1" />
                <button nz-button class="clear-btn" nzType="default" nzSize="small" (click)="clearSearch('searchNotes')" *ngIf="searchNotes">x</button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tr of transactionsTable.data">
            <ng-container *ngIf="tr.errorMessage != 'Stergere credit din cont' || (tr.errorMessage == 'Stergere credit din cont' && userRole == 'admin')">
              <td *ngIf="userRole != 'user'">{{ tr.id }}</td>
              <ng-container *ngIf="userRole != 'user'">
                <td>{{ tr.userFirstName }} {{ tr.userLastName }}</td>
                <td>{{ tr.userEmail }}</td>
              </ng-container>
              <td *ngIf="userRole == 'admin'">{{ tr.tipPersoana }}</td>
              <td *ngIf="tr.errorType == 1" nz-typography nzType="danger">Eroare plata cu cardul/sms</td>
              <td *ngIf="tr.errorType == 0" nz-typography nzType="success">
                <ng-container *ngIf="tr.transactionSystem == 'Mobilpay - card' || tr.transactionSystem == 'Mobilpay - card12' || tr.transactionSystem == 'Mobilpay - card24' || tr.transactionSystem == 'Mobilpay - card50'">Plata cu cardul</ng-container>
                <ng-container *ngIf="tr.transactionSystem == 'Mobilpay - carda1' || tr.transactionSystem == 'Mobilpay - carda2' || tr.transactionSystem == 'Mobilpay - carda3' || tr.transactionSystem == 'Mobilpay - carda4'">Plata abonament</ng-container>
                <ng-container *ngIf="tr.transactionSystem == 'Mobilpay - sms'">Plata cu sms</ng-container>
                <ng-container *ngIf="tr.errorMessage == 'Incarcare cont'">Incarcare cont</ng-container>
                <ng-container *ngIf="tr.errorMessage == 'Stergere credit din cont'">Stergere credit din cont</ng-container>
              </td>
              <td *ngIf="tr.errorType == 998" nz-typography nzType="success">
                <ng-container *ngIf="tr.errorMessage == 'Abonare cu success'">Abonare cu success</ng-container>
                <ng-container *ngIf="tr.errorMessage == 'Dezabonare cu success'">Dezabonare cu success</ng-container>
              </td>
              <td *ngIf="tr.errorType == 999" nz-typography nzType="success">Procesare balanţă</td>
              <td style="text-align: center">
                <ng-container *ngIf="tr.invoice != 0">{{ tr.invoice }}</ng-container>
              </td>
              <td style="text-align: center">
                <button
                  *ngIf="((tr.transactionSystem.startsWith('Mobilpay - card') && tr.currentMonth == true)) && tr.efacturaStatus != 'ok' && tr.transactionSystem !== 'Mobilpay - sms' && tr.errorMessage != 'Incarcare cont' && tr.errorMessage != 'Stergere credit din cont'"
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  nz-tooltip
                  nzTooltipTitle="Completeaza detaliile pentru generarea facturii"
                  (click)="showInvoiceModal(tr.id)"
                >
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </button>
                <button *ngIf="tr.transactionSystem.startsWith('Mobilpay - card') && tr.invoice != 0" nz-button nzType="default" nzShape="circle" nz-tooltip nzTooltipTitle="Descarca factura PDF" (click)="downloadInvoice(tr.invoice)">
                  <i nz-icon nzType="download" nzTheme="outline"></i>
                </button>
                <button
                  *ngIf="tr.transactionSystem.startsWith('Mobilpay - card') && tr.currentMonth == true && (tr.efacturaStatus == 'nok' || tr.efacturaStatus == '' || tr.efacturaStatus == 'xml invalid' || tr.efacturaStatus == null) && userRole == 'admin'"
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  nz-tooltip
                  nzTooltipTitle="Trimitere E-factura"
                  (click)="sendEfactura(tr.invoice)"
                >
                  <i nz-icon nzType="ie" nzTheme="outline"></i>
                </button>
              </td>
              <td>
                <ng-container *ngIf="tr.transactionSystem.startsWith('Mobilpay - card')">{{ tr.amount }} RON</ng-container>
                <ng-container *ngIf="tr.transactionSystem == 'Mobilpay - sms'">{{ tr.amount }} EUR</ng-container>
                <ng-container *ngIf="tr.errorMessage == 'Incarcare cont'">
                  {{ tr.balanceAmount }}
                </ng-container>
                <ng-container *ngIf="tr.errorMessage == 'Stergere credit din cont'">
                  {{ tr.balanceAmount }}
                </ng-container>
              </td>
              <td>{{ tr.errorMessage }}</td>
              <td>
                {{ tr.dateCreated | momentDate }}
              </td>
              <td *ngIf="userRole == 'admin'" >
                <ng-container *ngIf="(tr.transactionSystem == 'Mobilpay - card' || tr.transactionSystem == 'Mobilpay - card12' || tr.transactionSystem == 'Mobilpay - carda1' || tr.transactionSystem == 'Mobilpay - carda2' || tr.transactionSystem == 'Mobilpay - carda3' || tr.transactionSystem == 'Mobilpay - carda4') ">
                  <ng-container *ngIf="tr.efacturaStatus == 'ok'">
                    <nz-badge [nzStatus]="'success'" [nzText]="'Trimisa'" [ngClass]="'custom-success'" nz-tooltip="e-Factura trimisa cu success din Doctor Business"></nz-badge>
                  </ng-container>
                  <ng-container *ngIf="tr.efacturaStatus == 'in prelucrare'">
                    <nz-badge [nzStatus]="'warning'" [nzText]="'In procesare'" [ngClass]="'custom-warning'" nz-tooltip="e-Factura este in procesare de catre ANAF"></nz-badge>
                  </ng-container>
                  <ng-container *ngIf="tr.efacturaStatus == 'nok'">
                    <nz-badge [nzStatus]="'error'" [nzText]="'Netrimisa'" [ngClass]="'custom-error'" nz-tooltip="e-Factura nu a putut fi transmisa in ANAF. Datele clientului nu sunt corecte sau serverul ANAF a avut o problema la incarcarea facturii."></nz-badge>
                  </ng-container>
                  <ng-container *ngIf="tr.efacturaStatus == 'xml invalid'">
                    <nz-badge [nzStatus]="'error'" [nzText]="'XML invalid'" [ngClass]="'custom-error'" nz-tooltip="e-Factura nu a putut fi transmisa in ANAF. Datele clientului sau firmei nu sunt valide iar XML nu a putut fi generat"></nz-badge>
                  </ng-container>
                </ng-container>
              </td>
                <td style="text-align: center" *ngIf="userRole == 'admin' && tr.invoice != 0">
                  {{ tr.notes }}
                  <span nz-icon nzType="edit" nzTheme="outline" (click)="toggleShowEditNotes(tr.id)" style="cursor: pointer"></span>
                  <ng-container *ngIf="tr.id == showEditNotes">
                    <textarea nz-input style="width: 200px" placeholder="Adauga notitele tale" [(ngModel)]="notes" [nzAutosize]="{ minRows: 2, maxRows: 6 }"></textarea>
                  </ng-container>
                  <i nz-icon nzType="save" nzTheme="fill" *ngIf="tr.id == showEditNotes" (click)="saveNotes(tr.id)" style="cursor: pointer"></i>
                </td>
            </ng-container>
          </tr>
        </tbody>
      </nz-table>

      <nz-pagination class="custom-pagination" nzShowSizeChanger [nzPageIndex]="currentPage" [nzPageSize]="pageSize" [nzPageSizeOptions]="[10, 15, 20, 25, 50, 100]" [nzTotal]="totalItems" (nzPageIndexChange)="onPageChange($event)" (nzPageSizeChange)="onPageSizeChange($event)" style="float: right; margin-top: 10px; margin-bottom: 30px"></nz-pagination>
      <div style="clear: both;"></div>

      <nz-spin [nzSpinning]="!isSpinningReccuring">
        <ng-container *ngIf="reccurenceStatus == 'active' && isMobile == true">
          <div class="ant-statistic-title" style="margin-top: 15px">
            <div class="info-area">
              <div class="info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#000000">
                  <path
                    d="M546.67-426.67q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM240-293.33q-27.5 0-47.08-19.59-19.59-19.58-19.59-47.08v-373.33q0-27.5 19.59-47.09Q212.5-800 240-800h613.33q27.5 0 47.09 19.58Q920-760.83 920-733.33V-360q0 27.5-19.58 47.08-19.59 19.59-47.09 19.59H240ZM333.33-360H760q0-39 27.17-66.17 27.16-27.16 66.16-27.16V-640q-39 0-66.16-27.17Q760-694.33 760-733.33H333.33q0 39-27.16 66.16Q279-640 240-640v186.67q39 0 66.17 27.16Q333.33-399 333.33-360ZM800-160H106.67q-27.5 0-47.09-19.58Q40-199.17 40-226.67V-680h66.67v453.33H800V-160ZM240-360v-373.33V-360Z"
                  />
                </svg>
              </div>
              <div class="info-content">
                <p>{{ reccurenceMessage }}</p>
              </div>
              <!-- <button class="info-button" (click)="cancelRecurrence()">Anuleaza abonament</button> -->
              <button class="evo-button" (click)="cancelRecurrence()" style="height: 50px">
                <p style="font-size: 12px; margin-top: 10px">ANULEAZă ABONAMENT</p>
              </button>
            </div>
          </div>
        </ng-container>
      </nz-spin>
      <!-- <nz-dropdown-menu #email="nzDropdownMenu">
        <div class="ant-table-filter-dropdown">
          <div class="search-box">
            <input type="text" nz-input placeholder="Cauta email" [(ngModel)]="searchValue" />
            <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Cauta</button>
            <button nz-button nzSize="small" (click)="reset()">Reset</button>
          </div>
        </div>
      </nz-dropdown-menu>

      <nz-dropdown-menu #numePrenume="nzDropdownMenu">
        <div class="ant-table-filter-dropdown">
          <div class="search-box">
            <input type="text" nz-input placeholder="Cauta email" [(ngModel)]="searchNameValue" />
            <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Cauta</button>
            <button nz-button nzSize="small" (click)="reset()">Reset</button>
          </div>
        </div>
      </nz-dropdown-menu> -->

      <!-- <nz-row [nzGutter]="16" *ngIf="totalBalante == 0">
        <nz-col [nzSpan]="24" style="text-align: center; padding: 2rem 0">
          <h5 class="credits-text">
            Conform plăţilor efectuate mai ai disponibile
            <b>{{ totalBalante }}</b>
            încărcări de balanţă.
          </h5>
          <div class="ant-statistic-title">
            Alege tu cum dorești sa plătești: cu cardul, prin SMS,
            <br />
            sau ia-ţi un abonament avantajos de 12 încărcări de balanţă valabil pe o perioadă nelimitată.
          </div>
          <nz-radio-group [(ngModel)]="transactionType" nzButtonStyle="solid" class="btn-payments" (ngModelChange)="transactionTypeChanged()">
            <label nz-radio-button nzValue="sms" class="btn-sms">
              <span class="transaction-title">20 Euro prin SMS (Vodafone) pentru 1 încărcare de balanţă</span>
              <img src="/assets/img/btn-sms_20.png" />
            </label>
            <label nz-radio-button nzValue="card" class="btn-card">
              <span class="transaction-title">100 RON cu cardul pentru 1 încărcare de balanţă</span>
              <img src="/assets/img/btn-card_100.png" />
            </label>
            <label nz-radio-button nzValue="card12" class="btn-card card12">
              <span class="transaction-title">1000 RON cu cardul pentru 12 încărcări de balanţă</span>
              <img src="/assets/img/btn-card12_1000.png" />
            </label>
          </nz-radio-group>

          <form #form action="{{ mobilpayData.url }}" method="post" *ngIf="transactionType">
            <input type="hidden" name="env_key" value="{{ mobilpayData.env_key }}" />
            <input type="hidden" name="data" value="{{ mobilpayData.data }}" /> -->
      <!-- <button
                        nz-button
                        nzType="primary"
                        (click)="form.submit()"
                    >
                        Cumpara credit pentru procesarea balantelor
                    </button> -->
      <!-- </form>
        </nz-col>
      </nz-row> -->
      <nz-spin [nzSpinning]="!isSpinningReccuring">
        <ng-container *ngIf="reccurenceStatus == 'active' && !isMobile == true">
          <div class="ant-statistic-title" style="margin-top: 85px">
            <div class="info-area">
              <div class="info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#000000">
                  <path
                    d="M546.67-426.67q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM240-293.33q-27.5 0-47.08-19.59-19.59-19.58-19.59-47.08v-373.33q0-27.5 19.59-47.09Q212.5-800 240-800h613.33q27.5 0 47.09 19.58Q920-760.83 920-733.33V-360q0 27.5-19.58 47.08-19.59 19.59-47.09 19.59H240ZM333.33-360H760q0-39 27.17-66.17 27.16-27.16 66.16-27.16V-640q-39 0-66.16-27.17Q760-694.33 760-733.33H333.33q0 39-27.16 66.16Q279-640 240-640v186.67q39 0 66.17 27.16Q333.33-399 333.33-360ZM800-160H106.67q-27.5 0-47.09-19.58Q40-199.17 40-226.67V-680h66.67v453.33H800V-160ZM240-360v-373.33V-360Z"
                  />
                </svg>
              </div>
              <div class="info-content">
                <p>{{ reccurenceMessage }}</p>
              </div>
              <!-- <button class="info-button" (click)="cancelRecurrence()">Anuleaza abonament</button> -->
              <button class="evo-button" (click)="cancelRecurrence()" style="width: 200px; height: 50px">
                <p style="font-size: 12px; margin-top: 10px">ANULEAZă ABONAMENT</p>
              </button>
            </div>
          </div>
        </ng-container>
      </nz-spin>
    </div>
  </div>

  <nz-modal [(nzVisible)]="isVisibleModal" nzTitle="Completeaza detaliile pentru generarea facturii" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [nzOkDisabled]="!isFormValid()">
    <ng-container *nzModalContent>
      <form nz-form [formGroup]="contactDetailsForm" class="register-form">
        <nz-form-item>
          <nz-input-group [nzPrefix]="prefixTipPersoana">
            <nz-radio-group formControlName="tip_persoana" nzName="radiogroup" [(ngModel)]="radioTipPersoana" style="position: relative; left: 58px">
              <label nz-radio nzValue="Juridica">Persoana juridica</label>
              <label nz-radio nzValue="Fizica">Persoana fizica</label>
            </nz-radio-group>
          </nz-input-group>
          <ng-template #prefixTipPersoana>
            <i nz-icon nzType="reconciliation" nzTheme="fill"></i>
          </ng-template>
        </nz-form-item>

        <ng-container *ngIf="tipPersoana == 'Juridica'">
          <nz-form-item>
            <nz-input-group [nzPrefix]="prefixCompanyName">
              <input type="text" nz-input formControlName="companyName" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
              <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('companyName').value">Denumire Societate Comerciala</label>
            </nz-input-group>
            <ng-template #prefixCompanyName>
              <i nz-icon nzType="block" nzTheme="outline"></i>
            </ng-template>
          </nz-form-item>

          <nz-form-item>
            <nz-input-group [nzPrefix]="prefixCUI">
              <input type="text" nz-input formControlName="cui" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
              <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('cui').value">CUI</label>
            </nz-input-group>
            <ng-template #prefixCUI>
              <i nz-icon nzType="build" nzTheme="fill"></i>
            </ng-template>
          </nz-form-item>

          <nz-form-item>
            <nz-input-group [nzPrefix]="prefixRegCom">
              <input type="text" nz-input formControlName="regCom" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
              <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('regCom').value">Registru Comertului</label>
            </nz-input-group>
            <ng-template #prefixRegCom>
              <i nz-icon nzType="appstore" nzTheme="fill"></i>
            </ng-template>
          </nz-form-item>
        </ng-container>

        <nz-form-item>
          <nz-input-group [nzPrefix]="prefixFirstName">
            <input type="text" nz-input formControlName="firstName" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
            <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('firstName').value">Prenume</label>
          </nz-input-group>
          <ng-template #prefixFirstName>
            <i nz-icon nzType="user" nzTheme="outline"></i>
          </ng-template>
        </nz-form-item>

        <nz-form-item>
          <nz-input-group [nzPrefix]="prefixLastName">
            <input type="text" nz-input formControlName="lastName" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
            <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('lastName').value">Nume</label>
          </nz-input-group>
          <ng-template #prefixLastName>
            <i nz-icon nzType="user" nzTheme="outline"></i>
          </ng-template>
        </nz-form-item>

        <ng-container *ngIf="tipPersoana == 'Fizica'">
          <nz-form-item>
            <nz-input-group [nzPrefix]="prefixCUI">
              <input type="text" nz-input formControlName="cnp" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
              <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('cnp').value">CNP</label>
            </nz-input-group>
            <ng-template #prefixCUI>
              <i nz-icon nzType="build" nzTheme="fill"></i>
            </ng-template>
          </nz-form-item>
        </ng-container>

        <ng-container *ngIf="tipPersoana == 'Juridica'">
          <nz-form-item>
            <nz-input-group [nzPrefix]="prefixBankAccount">
              <input type="text" nz-input formControlName="bankAccount" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
              <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('bankAccount').value">Cont bancar</label>
            </nz-input-group>
            <ng-template #prefixBankAccount>
              <i nz-icon nzType="credit-card" nzTheme="fill"></i>
            </ng-template>
          </nz-form-item>
        </ng-container>

        <nz-form-item>
          <nz-input-group [nzPrefix]="prefixAddress">
            <input type="text" nz-input formControlName="address" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
            <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('address').value">Adresa</label>
          </nz-input-group>
          <ng-template #prefixAddress>
            <i nz-icon nzType="home" nzTheme="fill"></i>
          </ng-template>
        </nz-form-item>

        <nz-form-item style="bottom: 3px">
          <nz-input-group [nzPrefix]="prefixCountrySubentity" style="height: 34px; width: 100%" class="custom-select-container" data-field="country_subentity" (click)="handleContainerClick('country_subentity')">
            <label class="custom-select-placeholder" [class.shrink]="isPlaceholderShrinked['country_subentity']">Judet</label>
            <nz-select formControlName="country_subentity" nzShowSearch nzAllowClear style="width: 100%" [nzBorderless]="true" (focus)="handleSelectFocus('country_subentity')" (blur)="handleSelectBlur('country_subentity')" (ngModelChange)="handleModelChange($event, 'country_subentity')">
              <nz-option *ngFor="let judet of subentities" [nzLabel]="judet.label" [nzValue]="judet.value"></nz-option>
            </nz-select>
          </nz-input-group>
          <ng-template #prefixCountrySubentity><i nz-icon nzType="snippets" nzTheme="fill"></i></ng-template>
        </nz-form-item>

        <ng-container *ngIf="contactDetailsForm.value.country_subentity == 'RO-B'">
          <nz-form-item style="bottom: 3px">
            <nz-input-group [nzPrefix]="prefixCity" style="height: 34px; width: 100%" class="custom-select-container" data-field="city" (click)="handleContainerClick('city')">
              <label class="custom-select-placeholder" [class.shrink]="isPlaceholderShrinked['city']">Oras</label>
              <nz-select formControlName="city" nzShowSearch nzAllowClear style="width: 100%" [nzBorderless]="true" (focus)="handleSelectFocus('city')" (blur)="handleSelectBlur('city')" (ngModelChange)="handleModelChange($event, 'city')"><nz-option *ngFor="let sector of sectoare" [nzLabel]="sector.label" [nzValue]="sector.value"></nz-option></nz-select>
            </nz-input-group>
            <ng-template #prefixCity><i nz-icon nzType="home" nzTheme="fill"></i></ng-template>
          </nz-form-item>
        </ng-container>

        <ng-container *ngIf="contactDetailsForm.value.country_subentity != 'RO-B'">
          <nz-form-item>
            <nz-input-group [nzPrefix]="prefixCity">
              <input type="text" nz-input formControlName="city" class="custom-input" (focus)="handleFocus($event)" (blur)="handleBlur($event)" />
              <label class="custom-placeholder" [class.shrink]="contactDetailsForm.get('city').value">Oras</label>
            </nz-input-group>
            <ng-template #prefixCity>
              <i nz-icon nzType="copy" nzTheme="fill"></i>
            </ng-template>
          </nz-form-item>
        </ng-container>
      </form>
    </ng-container>
  </nz-modal>
</ng-container>
